import { inject, Injectable } from "@angular/core";
import { PAYPAL_CLIENT_ID, PAYPAL_INNATELY_CLIENT_ID } from "@equine-ui-nx/injection-tokens";


export enum PaypalClients {
  'IEA' = 'IEA',
  'Innately' = 'Innately'
}


@Injectable({
  providedIn: 'root'
})
export class PaypalClientSelectorService {

  private paypalClientId = inject(PAYPAL_CLIENT_ID);
  private paypalInnatelyClientId = inject(PAYPAL_INNATELY_CLIENT_ID);


  getPaypalClientId(client: PaypalClients): string {
    if (!client) {
      throw new Error('Client is required to get the client id');
    }

    if (client === PaypalClients.Innately) {
      return this.paypalInnatelyClientId;
    }

    return this.paypalClientId;
  }

}